// flourishConfig.js
import FlourishModule from '@flourish/live-api';

const Flourish = FlourishModule;

// Override _init
Flourish.Live.prototype._init = function (opts, callback) {
  const that = this;

  that._send('setFixedHeight', null, function () {
    that._draw(opts, function () {
      if (callback) {
        callback(that);
      }

      if (that._queued_methods !== null) {
        for (let i = 0; i < that._queued_methods.length; i++) {
          const m = that._queued_methods[i];
          m[0].apply(that, m.slice(1));
        }
      }

      that._queued_methods = null;
    });
  });
};

export default Flourish;
